import * as programConsts from "./constants";
import { EVENT_TOAST_MESSAGE, EVENT_ERROR_TOAST_MESSAGE } from "@/store/events";
import { EventBus } from "@/event-bus";
import transform from "./transform";
import { makeCall, makeDownload } from "@/utils/request";
import { downloadFileFromURL } from "@/utils/download-file";
import { downloadFile } from "@/utils/download-file";
import { buildOptions, getEndPoints } from "@/utils/api-call";
import commonUtils from "@/utils/common";
import moment from "moment-timezone";
import * as storeUtils from "../../../utils/store-handler";

export const state = {
  programs: [],
  allPrograms: [],
  program: {},
  currentProgramStatus: {},
  isProgramOwner: false,
  programClients: [],
  pagination: {
    count: 10,
    total: 0
  }
};

export const getters = {
  [programConsts.GETTERS_LIST_PROGRAM]: state => {
    return state.programs;
  },
  [programConsts.GETTERS_LIST_PROGRAM_CLIENTS]: state => {
    return state.programClients;
  },
  [programConsts.GETTERS_PROGRAM_DETAIL]: state => {
    return state.program;
  },
  [programConsts.GETTERS_CURRENT_PROGRAM_STATUS]: state => {
    return state.currentProgramStatus;
  },
  [programConsts.GETTERS_PROGRAMS_PAGINATION]: state => {
    return state.pagination;
  },
  [programConsts.GETTERS_LIST_ALL_PROGRAM]: state => {
    return state.allPrograms;
  },
};

export const actions = {
  [programConsts.ACTION_EXPORT_CSV]: ({ commit }, options) => {
    if (options.data && options.data.clientId && options.data.programId) {
      let token = localStorage.access_token.replace("Bearer ", "");
      const url = getEndPoints()
        .programs.exportCsv.replace(":programId", options.data.programId)
        .replace(":clientId", options.data.clientId)
        .replace(":tokenId", token);
      downloadFileFromURL(url, "export.csv");
      if (options.callback) {
        options.callback();
      }
    }
  },
  [programConsts.ACTION_GET_PROGRAM_LIST]: ({ commit }, options) => {
    let url = getEndPoints().programs.getList;
    if (options && options.clientId) {
      url = getEndPoints().programs.getListByClientId.replace(
        ":id",
        options.clientId
      );
    }
    makeCall(url, buildOptions("GET", options), commit).then(response => {
      if (response.data) {
        let transformList = transform.convertListProgramModel(response.data);
        response.data = transformList;
        commit(programConsts.MUTATION_SET_PROGRAM_LIST, response);
      }
      if (options.callback) {
        options.callback();
      }
    });
  },
  [programConsts.ACTION_GET_PROGRAM_TEMPLATE_LIST]: ({ commit }, options) => {
    let url = getEndPoints().programs.getListTemplate;
    makeCall(url, buildOptions("GET", options), commit).then(response => {
      if (response.data) {
        let transformList = transform.convertListProgramModel(response.data);
        response.data = transformList;
        commit(programConsts.MUTATION_SET_PROGRAM_LIST, response);
      }
      if (options.callback) {
        options.callback();
      }
    });
  },
  [programConsts.ACTION_GET_PROGRAM_LIST_RAW]: ({ commit }, options) => {
    let url = getEndPoints().programs.getList;
    if (options && options.clientId) {
      url = getEndPoints().programs.getListByClientId.replace(
        ":id",
        options.clientId
      );
    }
    makeCall(url, buildOptions("GET", options), commit).then(response => {
      if (response.data) {
        commit(programConsts.MUTATION_SET_PROGRAM_LIST, response);
      }
      if (options.callback) {
        options.callback();
      }
    });
  },
  [programConsts.ACTION_GET_PROGRAM_TEMPLATE_LIST_RAW]: (
    { commit },
    options
  ) => {
    let url = getEndPoints().programs.getListTemplate;
    makeCall(url, buildOptions("GET", options), commit).then(response => {
      if (response.data) {
        commit(programConsts.MUTATION_SET_PROGRAM_LIST, response);
      }
      if (options.callback) {
        options.callback();
      }
    });
  },
  [programConsts.ACTION_GET_ALL_PROGRAM_LIST]: ({ commit }, options) => {
    let url = getEndPoints().programs.getList;
    makeCall(url, buildOptions("GET", options), commit).then(response => {
      if (response.data) {
        commit(programConsts.MUTATION_SET_ALL_PROGRAM_LIST, response.data);
      }
      if (options.callback) {
        options.callback();
      }
    });
  },
  [programConsts.ACTION_GET_PROGRAM]: ({ commit }, options) => {
    let detailUrl = getEndPoints().programs.get.replace(":id", options.id);
    if (options.query && options.query.enableDemoGraphic) {
      detailUrl = detailUrl + "?enableDemoGraphic=" + options.query.enableDemoGraphic;
    }
    makeCall(detailUrl, buildOptions("GET", { params: options.params || {} }), commit).then(
      response => {
        if (response) {
          if (options.clientId) {
            response.clientId = options.clientId;
          }

          commit(
            programConsts.MUTATION_SET_PROGRAM,
            transform.convertProgramModel(response)
          );
          if (options.callback) {
            options.callback(response);
          }
        }
      },
      error => {
        console.log("error =", error);
      }
    );
  },
  [programConsts.ACTION_GET_CURRENT_PROGRAM_STATUS]: ({ commit }, options) => {
    let detailUrl = getEndPoints().programs.getCurrentProgramStatus.replace(":clientId", options.clientId).replace(":employeeId", options.employeeId).replace(":subgroupId", options.subgroupId);
    makeCall(detailUrl, buildOptions("GET", { params: options.params || {} }), commit).then(
      response => {
        if (response) {
          commit(programConsts.MUTATION_SET_CURRENT_PROGRAM_STATUS, response);
          if (options.callback) {
            options.callback(response);
          }
        }
      },
      error => {
        console.log("error =", error);
      }
    );
  },
  [programConsts.ACTION_ADD_PROGRAM]: ({ commit }, options) => {
    options.data.Status = commonUtils.getProgramStatus(
      options.data.StartDate,
      options.data.EndDate
    );
    let rawProgramData = transform.convertProgramRawModel(options.data);
    options.data = rawProgramData;
    makeCall(
      getEndPoints().programs.add,
      buildOptions("POST", options.data),
      commit
    )
      .then(response => {
        if (typeof response.error === "object") {
          let error = { message: "" };
          let messages = response.error.message;
          for (let key in messages) {
            if (messages.hasOwnProperty(key)) {
              error.message += "<p>" + messages[key] + "</p>";
            }
          }
          options.errorHandling(error);
        } else if (response.error === "string") {
          options.errorHandling(response.error);
        } else {
          commit(
            programConsts.MUTATION_SET_PROGRAM,
            transform.convertProgramModel(response)
          );
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          if (options.callback) {
            options.callback(response);
          }
        }
      })
      .catch(function(error) {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message &&
          error.response.data.error.message.title
        ) {
          EventBus.$emit(
            EVENT_ERROR_TOAST_MESSAGE,
            error.response.data.error.message.title
          );
          if (options.errorHandling) {
            options.errorHandling(error.response.data.error.message);
          }
        }
      });
  },
  [programConsts.ACTION_EDIT_PROGRAM]: ({ commit }, options) => {
    let rawProgramData = transform.convertProgramRawModel(options.data);
    const detailUrl = getEndPoints().programs.edit.replace(
      ":id",
      options.data.Id
    );
    makeCall(detailUrl, buildOptions("PATCH", rawProgramData), commit)
      .then(response => {
        if (response.error) {
          options.errorHandling(response.error);
        } else {
          if (options.successMessage && options.successMessage.length > 0) {
            EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          }

          if (response.tobaccoAttestationDeadlineLocalDate) {
            options.data.tobaccoAttestationDeadlineLocalDate = response.tobaccoAttestationDeadlineLocalDate
          }

          if (response.tobaccoProgramDeadlineLocalDate) {
            options.data.tobaccoProgramDeadlineLocalDate = response.tobaccoProgramDeadlineLocalDate
          }

          commit(programConsts.MUTATION_SET_PROGRAM, options.data);
          if (options.callback) {
            options.callback(response);
          }
        }
      })
      .catch(function(error) {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message &&
          error.response.data.error.message.message
        ) {
          let errorMessage = '';
          let errorKey = error.response.data.error.message.errorKey;
          if (errorKey === programConsts.SAVING_PROGRAM_ERROR.LABCORP_ACCOUNT_NUMBER_INVALID.key) {
            errorMessage = programConsts.SAVING_PROGRAM_ERROR.LABCORP_ACCOUNT_NUMBER_INVALID.message;
          } else if (errorKey === programConsts.SAVING_PROGRAM_ERROR.INVALID_END_DATE.key) {
            errorMessage = programConsts.SAVING_PROGRAM_ERROR.INVALID_END_DATE.message
          } else if (error.response.data.error.message.title &&
            error.response.data.error.message.title !== "") {

              errorMessage = error.response.data.error.message.title;

          } else {
            errorMessage = error.response.data.error.message.message;
          }
          EventBus.$emit(EVENT_ERROR_TOAST_MESSAGE, errorMessage);
          if (options.errorHandling) {
            options.errorHandling(error.response.data.error.message);
          }
        }
      });
  },
  [programConsts.ACTION_DELETE_PROGRAM]: ({ commit }, options) => {
    const detailUrl = getEndPoints().programs.delete.replace(":id", options.id);
    makeCall(detailUrl, buildOptions("DELETE", {}), commit)
      .then(response => {
        EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        if (options.callback) {
          options.callback(response);
        }
      })
      .catch(function(error) {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message &&
          error.response.data.error.message.title
        ) {
          EventBus.$emit(
            EVENT_ERROR_TOAST_MESSAGE,
            error.response.data.error.message.title
          );
          if (options.errorHandling) {
            options.errorHandling(error.response.data.error.message);
          }
        }
      });
  },
  [programConsts.ACTION_EXPORT_PROGRAM_TEMPLATE]: ({ commit }, options) => {
    makeCall(
      getEndPoints().programs.exportTemplate.replace(":id", options.id),
      buildOptions("POST", options.data),
      commit
    )
      .then(response => {
        if (response) {
          commit(
            programConsts.MUTATION_SET_PROGRAM,
            transform.convertProgramModel(response)
          );
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          if (options.callback) {
            options.callback(response);
          }
        }
      })
      .catch(function(error) {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message &&
          error.response.data.error.message.title
        ) {
          EventBus.$emit(
            EVENT_ERROR_TOAST_MESSAGE,
            error.response.data.error.message.title
          );
          if (options.errorHandling) {
            options.errorHandling(error.response.data.error.message);
          }
        }
      });
  },
  [programConsts.ACTION_CLONE_PROGRAM]: ({ commit }, options) => {
    makeCall(
      getEndPoints().programs.cloneProgram.replace(":id", options.id),
      buildOptions("POST", options.data),
      commit
    )
      .then(response => {
        if (response) {
          if (options.clientId) {
            response.clientId = options.clientId;
          }
          commit(
            programConsts.MUTATION_SET_PROGRAM,
            transform.convertProgramModel(response)
          );
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          if (options.callback) {
            options.callback(response);
          }
        }
      })
      .catch(function(error) {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message &&
          error.response.data.error.message.title
        ) {
          EventBus.$emit(
            EVENT_ERROR_TOAST_MESSAGE,
            error.response.data.error.message.title
          );
          if (options.errorHandling) {
            options.errorHandling(error.response.data.error.message);
          }
        }
      });
  },
  [programConsts.ACTION_SET_EMPTY_PROGRAM]: ({ commit }) => {
    commit(programConsts.MUTATION_SET_PROGRAM, {});
  },
  [programConsts.ACTION_SET_PROGRAM]: ({ commit }, payload) => {
    commit(programConsts.MUTATION_SET_PROGRAM, payload);
  },
  [programConsts.ACTION_SET_CLIENT_PROGRAM]: ({ commit }, options) => {
    const detailUrl = getEndPoints().programs.assignProgramEmployer.replace(
      ":id",
      options.ProgramId
    );
    let clients = transform.convertListClientRawModel(options.data);
    makeCall(detailUrl, buildOptions("POST", clients), commit)
      .then(response => {
        if (response.error) {
          options.errorHandling(response.error);
        } else if (options.callback) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          options.callback(transform.convertListClientModel(response));
        }
      })
      .catch(function(error) {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message &&
          error.response.data.error.message.title
        ) {
          if (error.response.data.error.message.errorKey) {
            let objProgramError = JSON.parse(
              error.response.data.error.message.errorKey
            );
            if (objProgramError && objProgramError.programId) {
              EventBus.$emit(
                EVENT_ERROR_TOAST_MESSAGE,
                error.response.data.error.message.title +
                  " - ProgramId: " +
                  objProgramError.programId +
                  " - Program Name: " +
                  objProgramError.programName
              );
            }
          } else {
            EventBus.$emit(
              EVENT_ERROR_TOAST_MESSAGE,
              error.response.data.error.message.title
            );
          }
          if (options.errorHandling) {
            options.errorHandling(error.response.data.error.message);
          }
        }
      });
  },
  [programConsts.ACTION_CONVERT_LIST_EMPLOYER_TO_LIST_CLIENT]: (
    { commit },
    options
  ) => {
    commit(
      programConsts.MUTATION_SET_PROGRAM_CLIENTS_LIST,
      transform.convertListEmployerToListClientModel(
        options.data,
        options.programId
      )
    );
  },
  [programConsts.ACTION_SET_PROGRAM_LIST]: ({ commit }, options) => {
    commit(programConsts.MUTATION_SET_PROGRAM_LIST, options);
  },
  [programConsts.ACTION_UPDATE_PROGRAM_SUBGROUP]: ({ commit }, options) => {
    const url = getEndPoints().programs.updateBySubgroup;
    makeCall(url, buildOptions("POST", options.data), commit).then(
      response => {
        if (options.callback) {
          options.callback(response);
        }
      },
      error => {
        console.log("error =", error);
      }
    );
  },
  [programConsts.ACTION_PREVIEW_HPSF]: ({ commit }, options) => {
    const url = getEndPoints().programs.previewHpsf.replace(":formType", options.formType);
    makeCall(url, { ...buildOptions("GET", {}), responseType: 'blob' }, commit).then(
      response => {
        if (options.callback) {
          options.callback(response);
        }
      },
      error => {
        console.log("error =", error);
      }
    );
  },
  [programConsts.ACTION_GET_HPSF_FORM_TYPE_LIST]: ({ commit }, options) => {
    const url = getEndPoints().programs.getHpsfFormTypeList;
    makeCall(url, buildOptions("GET", {}), commit).then(
      response => {
        if (options.callback) {
          options.callback(response);
        }
      },
      error => {
        console.log("error =", error);
      }
    );
  }
};

export const mutations = {
  [programConsts.MUTATION_SET_PROGRAM_LIST]: (state, payload) => {
    state.programs = payload.data;
    state.pagination =
      payload.meta && payload.meta.pagination
        ? {
            ...{
              count: payload.meta.pagination.count,
              total: parseInt(payload.meta.pagination.total),
              itemsPerPage: payload.meta.pagination.per_page,
              totalPage: payload.meta.pagination.total_pages,
              current_page: parseInt(payload.meta.pagination.current_page)
            }
          }
        : state.pagination;
  },
  [programConsts.MUTATION_SET_ALL_PROGRAM_LIST]: (state, payload) => {
    payload.forEach(program => {
      state.allPrograms.push({
        ProgramId: program.id,
        ProgramName: program.name
      });
    });
  },
  [programConsts.MUTATION_SET_PROGRAM_CLIENTS_LIST]: (state, payload) => {
    state.programClients = payload;
  },
  [programConsts.MUTATION_SET_PROGRAM]: (state, payload) => {
    payload.maxDateOfProgram = commonUtils.diffDate(
      payload.StartDate,
      payload.EndDate
    );
    payload.CanEdit = payload.Status === programConsts.PROGRAM_STATUS.DRAFT;
    state.program = transform.convertProgramTobaccoDates(payload);
  },
  [programConsts.MUTATION_SET_CURRENT_PROGRAM_STATUS]: (state, payload) => {
    state.currentProgramStatus = payload;
  },
  [programConsts.MUTATION_SET_CLIENT_PROGRAM]: (state, payload) => {
    if (state.program && payload) {
      state.program.Clients = payload;
    }
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_programs/index.js